import {z as r} from 'zod';

const competitorSchema = r.object({
    id: r.number(),
    name: r.string(),
});

export type CompetitorType = r.infer<typeof competitorSchema>;

export type CompetitorsResponseType = {
    [brandId: number]: Array<CompetitorType>;
};

export const competitorsResponseSchema = r.record(
    r.preprocess((number) => Number.parseInt(r.string().parse(number), 10), r.number()),
    r.array(competitorSchema)
);

const competitorCompaniesSchema = r.object({
    id: r.number(),
    name: r.string(),
    address: r.string(),
    code: r.string().optional(),
});

export const competitorCompaniesResponseSchema = r.object({
    results: r.array(competitorCompaniesSchema),
});

export type CompetitorCompanyType = r.infer<typeof competitorCompaniesSchema>;
